import { render, staticRenderFns } from "./compVideo.vue?vue&type=template&id=a6839e38&"
import script from "./compVideo.vue?vue&type=script&lang=js&"
export * from "./compVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6839e38')) {
      api.createRecord('a6839e38', component.options)
    } else {
      api.reload('a6839e38', component.options)
    }
    module.hot.accept("./compVideo.vue?vue&type=template&id=a6839e38&", function () {
      api.rerender('a6839e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/components/compVideo.vue"
export default component.exports